import { AbstractFilterBuilder } from "./AbstractFilterBuilder";


export class ExtractFilterBuilder extends AbstractFilterBuilder {

    public build(value: string): string {
        return `["Document","${this.field}","like","%25${value}%25"]`;
    }
    
}